{
    "de": {
        "TITLE_WITH_LOCATION": "Wettervorhersage für {{location}}",
        "MIN_TEMPERATURE": "T: {{temp}}°",
        "MAX_TEMPERATURE": "H: {{temp}}°",
        "SUNSHINE_DURATION_HOURS": "{{duration}} h",
        "WEATHER_CODE_0": "Sonnig",
        "WEATHER_CODE_1": "Heiter",
        "WEATHER_CODE_2": "Teilweise bewölkt",
        "WEATHER_CODE_3": "Bewölkt",
        "WEATHER_CODE_45": "Nebel",
        "WEATHER_CODE_48": "Gefrierender Nebel",
        "WEATHER_CODE_51": "Leichter Niesel",
        "WEATHER_CODE_53": "Mäßiger Niesel",
        "WEATHER_CODE_55": "Starker Niesel",
        "WEATHER_CODE_56": "Leichter gefrierender Niesel",
        "WEATHER_CODE_57": "Starker gefrierender Niesel",
        "WEATHER_CODE_61": "Leichter Regen",
        "WEATHER_CODE_63": "Mäßiger Regen",
        "WEATHER_CODE_65": "Starker Regen",
        "WEATHER_CODE_66": "Leichter gefrierender Regen",
        "WEATHER_CODE_67": "Starker gefrierender Regen",
        "WEATHER_CODE_71": "Leichter Schneefall",
        "WEATHER_CODE_73": "Mäßiger Schneefall",
        "WEATHER_CODE_75": "Starker Schneefall",
        "WEATHER_CODE_77": "Graupel",
        "WEATHER_CODE_80": "Leichter Regenschauer",
        "WEATHER_CODE_81": "Mäßiger Regenschauer",
        "WEATHER_CODE_82": "Starker Regenschauer",
        "WEATHER_CODE_85": "Leichter Schneeschauer",
        "WEATHER_CODE_86": "Starker Schneeschauer",
        "WEATHER_CODE_95": "Gewitter",
        "WEATHER_CODE_96": "Leichtes Hagelgewitter",
        "WEATHER_CODE_99": "Starkes Hagelgewitter",
        "WEATHER_CODE_0_NIGHT": "Klarer Himmel",
        "WEATHER_CODE_1_NIGHT": "Heiter",
        "WEATHER_CODE_2_NIGHT": "Teilweise bewölkt",
        "WEATHER_CODE_UNKNOWN": "Unbekannt"
    },
    "en": {
        "TITLE_WITH_LOCATION": "Weather forecast for {{location}}",
        "MIN_TEMPERATURE": "L: {{temp}}°",
        "MAX_TEMPERATURE": "H: {{temp}}°",
        "SUNSHINE_DURATION_HOURS": "{{duration}} h",
        "WEATHER_CODE_0": "Sunny",
        "WEATHER_CODE_1": "Mainly clear",
        "WEATHER_CODE_2": "Partly cloudy",
        "WEATHER_CODE_3": "Overcast",
        "WEATHER_CODE_45": "Fog",
        "WEATHER_CODE_48": "Depositing rime fog",
        "WEATHER_CODE_51": "Light drizzle",
        "WEATHER_CODE_53": "Moderate drizzle",
        "WEATHER_CODE_55": "Dense drizzle",
        "WEATHER_CODE_56": "Slight freezing drizzle",
        "WEATHER_CODE_57": "Dense freezing drizzle",
        "WEATHER_CODE_61": "Slight rain",
        "WEATHER_CODE_63": "Moderate rain",
        "WEATHER_CODE_65": "Heavy rain",
        "WEATHER_CODE_66": "Light freezing rain",
        "WEATHER_CODE_67": "Heavy freezing rain",
        "WEATHER_CODE_71": "Slight snow fall",
        "WEATHER_CODE_73": "Moderate snow fall",
        "WEATHER_CODE_75": "Heavy snow fall",
        "WEATHER_CODE_77": "Snow grains",
        "WEATHER_CODE_80": "Slight rain showers",
        "WEATHER_CODE_81": "Moderate rain showers",
        "WEATHER_CODE_82": "Heavy rain showers",
        "WEATHER_CODE_85": "Slight snow showers",
        "WEATHER_CODE_86": "Heavy snow showers",
        "WEATHER_CODE_95": "Thunderstorm",
        "WEATHER_CODE_96": "Thunderstorm with slight hail",
        "WEATHER_CODE_99": "Thunderstorm with heavy hail",
        "WEATHER_CODE_0_NIGHT": "Clear sky",
        "WEATHER_CODE_1_NIGHT": "Mainly clear",
        "WEATHER_CODE_2_NIGHT": "Partly cloudy",
        "WEATHER_CODE_UNKNOWN": "Unknown"
    }
}
